if(!customElements.get('product-media-gallery')) {
    class ProductMediaGallery extends HTMLElement {
        constructor() {
            super();
            this.variantIdChangedUnsubscriber = undefined;
            this.galleryImageChangedUnsubscriber = undefined;
            this.swiperThumbnails = null;
            this.swiperMain = null;
            this.productDataCache = null;
            this.lastPathname = '';
        }
        connectedCallback() {
            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueSelectionChange,
                this._findVariantImage.bind(this)
            );
            this.onGalleryImageChangedUnsubcriber = subscribe(
                PUB_SUB_EVENTS.galleryImageChanged,
                this._setGalleryImage.bind(this)
            );
            this.swiperThumbnails = new Swiper(".gallery-thumbnails", {
                spaceBetween: 10,
                slidesPerView: 6.6,
                watchSlidesProgress: true,
                breakpoints: {
                    0: {
                        slidesPerView: 5.2,
                         spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 6.6,
                         spaceBetween: 10,
                    }
                }
            });
            this.swiperMain = new Swiper(".main-gallery", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: this.swiperThumbnails,
                },
                on: {
                  slideChange: function () {
                        const activeIndex = this.activeIndex;
                        const visibleThumbs = this.swiperThumbnails?.params?.slidesPerView;
               
                        if (activeIndex >= this.swiperThumbnails?.activeIndex + visibleThumbs - 2) {
                            this.swiperThumbnails?.slideTo(activeIndex - 2);
                        }

                        if (activeIndex < this.swiperThumbnails?.activeIndex) {
                            this.swiperThumbnails?.slideTo(Math.max(activeIndex - 2, 0));
                        }
                    }
                  }
            });
        }
      
        disconnectedCallback() {
            if (this.variantIdChangedUnsubscriber) {
                this.variantIdChangedUnsubscriber();
            }
        }

        async _findVariantImage({ data: { selectedOptionsValue } }) {
            // 1. Fast path for empty selections
            if (!selectedOptionsValue?.length) return;

            // 2. Cache product data
            const currentPath = window.location.pathname;
            if (!this.productDataCache || this.lastPathname !== currentPath) {
                try {
                    const res = await fetch(`${currentPath}.json`);
                    this.productDataCache = await res.json();
                    this.lastPathname = currentPath;
                } catch (err) {
                    console.error('Fetch error:', err);
                    return;
                }
            }

            // 3. Fast exit if no variants
            const variants = this.productDataCache.product?.variants;
            if (!variants || !variants.length) return;

            // 4. Pre-process search terms once
            const searchTerms = new Set(
                selectedOptionsValue.map(opt => opt.toLowerCase().trim())
            );

            // 5. Optimized search using for...of loop
            let matchedVariant = null;
            for (const variant of variants) {
                const variantTitle = variant.title.toLowerCase();
                let allMatch = true;
                
                for (const term of searchTerms) {
                    if (!variantTitle.includes(term)) {
                        allMatch = false;
                        break; // Early exit inner loop
                    }
                }
                
                if (allMatch) {
                    matchedVariant = variant;
                    break; // Early exit outer loop
                }
            }

            // 6. Fast DOM lookup
            if (matchedVariant?.image_id && this.swiperMain) {
                const selector = `[data-image-id="${matchedVariant.image_id}"]`;
                const imageEl = this.querySelector(selector);
                if (imageEl) {
                    this.swiperMain.slideTo(parseInt(imageEl.dataset.index));
                }
            }
        }

        async _setGalleryImage({data: { galleryImage }}) {
            const slideGalleryImage = document.querySelector(`[data-gallery-image="files/${galleryImage}"]`);
            slideGalleryImage && this.swiperMain.slideTo(parseInt(slideGalleryImage.dataset.index));
        }
    }
    customElements.define('product-media-gallery', ProductMediaGallery);
}